import { render, staticRenderFns } from "./status-c.vue?vue&type=template&id=72068a8d&"
import script from "./status-c.vue?vue&type=script&lang=js&"
export * from "./status-c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports